import ProgressBar from "@ramonak/react-progress-bar";

const StrengthPerformance = ({infoEval,type}:any) => {  
const res=infoEval.infoEvalByCompetence[0].califFinal
//const txt=infoEval.infoEvalByCompetence[0].evalTxt
  return (
    <div className="infoEvalDebilityStrengthGraph"> 
        <div className="containerTxtDebilityStrength"> <span className="txtNameDebilityStrength">{infoEval.nameCompetence}</span></div>  
        
        <div className="containerProgressBarDebilityStrength">
        <div className="containerProgressBarEvalModel">
        {
        infoEval.estado === 'strength' ?
        <ProgressBar 
                completed={res}
                customLabel=" "                                           
                labelSize='12px'
                bgColor='#3BCBB0' 
                width="100%"     
                height='25px'                     
                />:
                <ProgressBar 
                completed={res}
                customLabel=" "                                           
                labelSize='12px'
                bgColor='#D83A51' 
                width="100%"     
                height='25px'                     
                />
        }
        </div>  
         <div className="containerTxtStrengthDebilityEval">
         {  infoEval.estado === 'strength' ?
            <span className="calfInfoDebilityStrength">{res >100?100:res}</span>
            :
            <span className="calfInfoDebilityStrengthBad">{res >100?100:res}</span>
         }
          </div>  
          {/* <div className="containerTxtStrengthDebilityEval">
         {  infoEval.estado === 'strength' ?
            <span className="calfInfoDebilityStrength">{txt}</span>
            :
            <span className="calfInfoDebilityStrengthBad">{txt}</span>
         }
          </div>   */}
        </div>
</div>
  )
}

export default StrengthPerformance